module.exports = __webpack_public_path__ + "custom-config/configs/index.js";


//////////////////
// WEBPACK FOOTER
// ./src/configs/index.config
// module id = 34ml
// module chunks = 2 3 4 6 7 8 9